import {isCoches} from '../utils.js'

export default async params => {
  const pixels = isCoches
    ? await import('./coches/index.js').then(({default: pixels}) => pixels)
    : await import('./motos/index.js').then(({default: pixels}) => pixels)

  return pixels.forEach(track => track(params))
}
